import { DEFAULT_CARD_PREFERENCES } from './CurrentDocument';


export default DEFAULT_CARD_PREFERENCES;
